import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  upnpList: [],
  account: null,
  upnp: null,
  error: false,
  success: false,
  loading: false,
  loaded: false,
  realUpnp: null
};
const resetUpnpState = (state, action) => {
  return updateObject(state, initialState)
}
const initUpnpStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded: false
  });
};

const setUpnp = (state, action) => {
  return updateObject(state, {
    realUpnp: action.realUpnp,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchUpnpFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};
const changeUpnpFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: true
  });
};

const changeUpnpSuccess = (state, action) => {

  return updateObject(state, {
    loading: false,
    success: true
  });
};
const resetUpnpErrorSuccess = (state, action) => {
  return updateObject(state, {
    success:false,
    error:false
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_UPNP_START:
      return initUpnpStart(state, action);
    case actionTypes.SET_UPNP:
      return setUpnp(state, action);
    case actionTypes.FETCH_UPNP_FAILED:
      return fetchUpnpFailed(state, action);
    case actionTypes.CHANGE_UPNP_SUCCESS:
      return changeUpnpSuccess(state, action);
    case actionTypes.CHANGE_UPNP_FAILED:
      return changeUpnpFailed(state, action);
    case actionTypes.RESET_UPNP_ERROR_SUCCESS:
      return resetUpnpErrorSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
